<template>
  <div class="w-full flex gap-2">
    <button v-if="documentation.isStarred" @click="() => {starDocumentation()}"
            class="text-yellow-500 p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star" width="24"
            height="24"/>
    </button>
    <button v-if="!documentation.isStarred" @click="() => {starDocumentation()}"
            class="p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star-outline" width="24"
            height="24"/>
    </button>
    {{documentation.externalID}}
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {Icon} from '@iconify/vue';
import Documentation from "@/models/customer/Documentation";

export default defineComponent({
  setup() {
    const documentation = ref<Documentation>(new Documentation())
    return {
      documentation,
    }
  },
  components: {
    Icon
  },
  mounted() {
    /* @ts-ignore */
    this.documentation = Documentation.from(this.params?.data)
  },
  methods: {
    notify() {
      /* @ts-ignore */
      this.params.reload();
    },
    async starDocumentation() {
      try {
        const res = await this.$http.put<Documentation>(Documentation.ENDPOINT + `/${this.documentation.id}/star`, this.documentation);
        this.documentation = Documentation.from(res)
        this.notify();
      } catch (e) {
        console.log(e)
      }
    }
  },
})
</script>
